var map = {
	"./BasicPage.vue": [
		"9a45"
	],
	"./Blog.vue": [
		"fd3f",
		"drupal-custom-component1"
	],
	"./CaseStudies.vue": [
		"6590",
		"drupal-custom-component2"
	],
	"./CollaborateWithUs.vue": [
		"b361",
		"drupal-custom-component3"
	],
	"./Collaborations.vue": [
		"40ca",
		"drupal-custom-component4"
	],
	"./ComputingResources.vue": [
		"9205",
		"drupal-custom-component5"
	],
	"./Consulting.vue": [
		"a20b",
		"drupal-custom-component6"
	],
	"./Contacts.vue": [
		"c93c",
		"drupal-custom-component7"
	],
	"./CookiePolicy.vue": [
		"8368",
		"drupal-custom-component8"
	],
	"./Default.vue": [
		"a4f6",
		"drupal-custom-component9"
	],
	"./EqualityDiversityInclusion.vue": [
		"ead1",
		"drupal-custom-component10"
	],
	"./EventsForThePublic.vue": [
		"65ca",
		"drupal-custom-component11"
	],
	"./FundAScholarship.vue": [
		"d17b",
		"drupal-custom-component12"
	],
	"./Grants.vue": [
		"5faf",
		"drupal-custom-component13"
	],
	"./Home.vue": [
		"bb51",
		"drupal-custom-component14~drupal-custom-component18~drupal-custom-component20",
		"drupal-custom-component14"
	],
	"./HowToApply.vue": [
		"31ff",
		"drupal-custom-component15"
	],
	"./InformationForStudents.vue": [
		"f668",
		"drupal-custom-component16"
	],
	"./Mission.vue": [
		"486a",
		"drupal-custom-component17"
	],
	"./News.vue": [
		"a2f9",
		"drupal-custom-component14~drupal-custom-component18~drupal-custom-component20",
		"drupal-custom-component18"
	],
	"./NotFound.vue": [
		"9703"
	],
	"./Opportunities.vue": [
		"21ca",
		"drupal-custom-component14~drupal-custom-component18~drupal-custom-component20",
		"drupal-custom-component20"
	],
	"./OurExpertise.vue": [
		"094f",
		"drupal-custom-component21"
	],
	"./People.vue": [
		"bea6",
		"drupal-custom-component22"
	],
	"./PhdInTheoreticalAndScientificDataScience.vue": [
		"35d5",
		"drupal-custom-component23"
	],
	"./PrivacyPolicy.vue": [
		"729e",
		"drupal-custom-component24"
	],
	"./Projects.vue": [
		"acca",
		"drupal-custom-component25"
	],
	"./Publications.vue": [
		"cbf6",
		"drupal-custom-component26"
	],
	"./ResearchUnits.vue": [
		"c1e2",
		"drupal-custom-component27"
	],
	"./SeminarsAndJournalClubs.vue": [
		"ffc6",
		"drupal-custom-component28"
	],
	"./Sitemap.vue": [
		"fa05"
	],
	"./StudentsProjects.vue": [
		"31e9",
		"drupal-custom-component30~drupal-custom-component37",
		"drupal-custom-component30"
	],
	"./TaughtPhdModules.vue": [
		"eca6",
		"drupal-custom-component31"
	],
	"./TeachingStaff.vue": [
		"093e",
		"drupal-custom-component32"
	],
	"./WhyDataScienceForTheNaturalSciences.vue": [
		"013d",
		"drupal-custom-component33"
	],
	"./details/Article.vue": [
		"ec40",
		"drupal-custom-component34"
	],
	"./details/Event.vue": [
		"68a6",
		"drupal-custom-component35"
	],
	"./details/News.vue": [
		"93ff",
		"drupal-custom-component36"
	],
	"./details/Person.vue": [
		"b073",
		"drupal-custom-component30~drupal-custom-component37",
		"drupal-custom-component37"
	],
	"./details/Project.vue": [
		"545b",
		"drupal-custom-component38"
	],
	"./details/Research_unit.vue": [
		"cfc6",
		"drupal-custom-component39"
	],
	"./details/Seminar.vue": [
		"712a",
		"drupal-custom-component40"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;